/**
 * An enum for Task Type IDs
 */
export enum TaskTypeId {
	/**
	 * A standard task requiring the operator to check to complete
	 */
	Basic = 1,

	/**
	 * Requires the operator to enter some text
	 */
	Input = 2,

	/**
	 * Gives two buttons, Yes and No
	 */
	YesNo = 3,

	/**
	 * A task completed when the operator dispatches a guard
	 */
	Dispatch = 4,

	/**
	 * A task that opens a URL for the operator
	 */
	Url = 5,

	/**
	 * Send a mass notification using an applicable integration
	 */
	MassNotification = 6,

	/**
	 * Provides the ability to select an option from a pre-configured selection
	 */
	Choices = 7,

	/**
	 * Provides the ability to navigate through pre-configured call lists as part of an action plan
	 */
	CallContact = 8,

	/**
	 * Produces a Situation Report
	 */
	SitRep = 9,

	/**
	 * Logs a message to CCure
	 */
	CCure = 10,

	/**
	 * Shows attached Audit clips
	 */
	Audit = 11,

	/**
	 * Allows the operator to select an option from a predefined data source
	 */
	DynamicDataList = 12,

	/**
	 * Action to trigger a relay from list of options
	 */
	ControlRelay = 13,

	/**
	 * Raise event to be further investigated in case management
	 */
	RaiseToCases = 14,

	/**
	 * Gives three options for the completion of an assessment Tour
	 */
	AssessmentComplete = 15,

	/**
	 * A task for selecting the outcome of this event, pre-fills the event close dialog
	 */
	EventOutcome = 16
}
